import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { changeComponentHeight } from '../features/general/generalSlice';

function useComponentHeight() {
  const dispatch = useDispatch();
  /* 
    The windowHeight useState and the useEffect below it is used for calculating the outer Box height. I did that because I want the height of the nav to always be 80px and and the dashBoard to have the rest of the visible height on the screen so that on any kind of screen I only see the navbar and the dashboard on the top visible screen
  */
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    useEffect(() => {
      const handleResize = () => { setWindowHeight(window.innerHeight); };
      window.addEventListener('resize', handleResize);
      return () => { window.removeEventListener('resize', handleResize); };
    }, []);
    // I used the next two lines of code to calculate the amount of screen height left in percent and put it in variable size to make it the hight of the outer Box.
    let componentHeight = 6400 / windowHeight;
    componentHeight = 100 - componentHeight;
    dispatch(changeComponentHeight(componentHeight));
}

export default useComponentHeight;
